import React, { forwardRef, LegacyRef } from 'react';

import Link from 'next/link';

import { useMobileView } from '../../../hooks/useMobileView';
import { ServiceOSLogin } from '../../ServiceOS/ServiceOSLogin/ServiceOSLogin';
import { TNavigation, LinkProps } from '../Header.types';
import { HeaderBasket } from '../HeaderBasket/HeaderBasket';
import { HeaderInitials } from '../HeaderInitials/HeaderInitials';
import { HeaderNavWrapper, HeaderNavItem, HeaderNavItems } from './HeaderNav.style';

const StatefulLink = forwardRef(function StatefulLink(
  { onClick, href, title }: LinkProps,
  ref: LegacyRef<HTMLAnchorElement>
) {
  return (
    <a href={href} onClick={onClick} ref={ref}>
      <HeaderNavItem>{title}</HeaderNavItem>
    </a>
  );
});

export const HeaderNav = ({
  navigation,
  setOpen,
  showBasket,
  showInitials,
  basketData,
  useServiceOsAuth,
  basketButtonText,
  removeCartButton,
}: TNavigation) => {
  const { isMobile } = useMobileView();

  return (
    <HeaderNavWrapper>
      {useServiceOsAuth && !isMobile && <ServiceOSLogin />}
      {navigation.map((navigationItem) => {
        return (
          <Link
            key={navigationItem._uid}
            href={
              navigationItem.item.cached_url.startsWith('http')
                ? navigationItem.item.cached_url
                : `/${navigationItem.item.cached_url}`
            }
            passHref
          >
            <StatefulLink title={navigationItem.title} onClick={() => setOpen(false)} />
          </Link>
        );
      })}
      {(showBasket || showInitials) && (
        <HeaderNavItems>
          {!removeCartButton && showBasket && (
            <HeaderBasket
              basketData={basketData}
              basketButtonText={basketButtonText}
              useServiceOsAuth={useServiceOsAuth}
            />
          )}
          {showInitials && <HeaderInitials />}
        </HeaderNavItems>
      )}
    </HeaderNavWrapper>
  );
};
